import React, { useState, useEffect, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import axios from 'axios'
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from '../../../../layouts/SnackBars';
import LinearProgress from '@material-ui/core/LinearProgress';

import AddBox from '@material-ui/icons/AddBox';
import PrintIcon from '@material-ui/icons/Print';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import mockData from './image';
import bossLicense from './finance_boss_license';
import moment from 'moment';
import localization from 'moment/locale/th';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  tableWrapper: {
    maxWidth: 3000,
    overflow: 'auto',
  },
  progress: {
    margin: theme.spacing(2),
  },
}));

const SlipsTable = props => {
  const { moneyTypes, typePersons, budgetYears, loadValue } = props;
  const [columns, setColumns] = useState([]);
  const classes = useStyles();
  const [images] = useState(mockData);
  const [boss_license] = useState(bossLicense);
  const [data] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState();
  const [snackVariant, setSnackVariant] = useState('success');
  const [personData, setPersonData] = useState([]);
  const [slipDatas, setSlipDatas] = useState([]);
  const [profile] = useState(JSON.parse(localStorage.getItem('profile')));
  const [moneyType, setMoneyType] = useState([]);
  let source = axios.CancelToken.source();

  const loadMoneyType = async () => {
    const url = 'https://eslip.snru.ac.th/backend/api/moneytype';
    try {
      const result = await axios(url, {
        cancelToken: source.token
      });
      return result.data.data;
    } catch (error) {
      console.log(error)
    }
  };


  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };

  const loadData = async (typePerson) => {
    try {
      let newperson = [];
      setLoading(true);
      setPersonData([]);
      const url = 'https://eslip.snru.ac.th/backend/api/users/personsByType/' + typePerson;
      const result = await axios(url, {
        cancelToken: source.token
      });
      const moneytype = await loadMoneyType();
      setMoneyType(moneytype);
      const slipdata = await loadSlipData(budgetYears);
      setSlipDatas(slipdata);
      const etcdata = await loadEtcData(budgetYears);
      const persons = result.data.data.map(person => ({
        citizen_id: person.citizen_id,
        position_num: person.position_num,
        position_name: person.position_name,
        agency_name: person.agency_name,
        fullname: person.prefix_name + person.fnamethai + " " + person.lnamethai,
      }));

      persons.forEach(person => {
        const slips = slipdata.filter((slip) => {
          return slip.citizen_id === person.citizen_id
        })

        const etcs = etcdata.filter((etc) => {
          return etc.citizen_id === person.citizen_id
        })

        let sum_income = 0;
        let sum_deduct = 0;
        let sum_salary = 0;

        slips.forEach(slip => {
          (slip.tb_money_type.income_type_id === 1) ? (sum_income = sum_income + slip.eslip_value) : (sum_deduct = sum_deduct + slip.eslip_value);
          (slip.money_type_id === 1) && (sum_salary = sum_salary + slip.eslip_value);
          person = { ...person, [slip.money_type_id]: currencyFormat(slip.eslip_value) }
        });

        person = { ...person, sumincome: currencyFormat(sum_income) }
        person = { ...person, sumdeduct: currencyFormat(sum_deduct) }
        person = { ...person, sumtotal2: currencyFormat(sum_salary - sum_deduct) }
        person = { ...person, sumtotal: currencyFormat(sum_income - sum_deduct) }

        etcs.forEach(etc => {
          person = { ...person, 'eslip_number': etc.auto_id, 'bank_name': etc.bank_name, 'bank_account': etc.bank_account, 'project_activities_id': etc.project_activities_id, 'etc': etc.etc }
        });
        newperson.push(person)
      });
      setLoading(false);
      setPersonData(newperson);
    } catch (error) {
      console.log(error)
    }
  };

  const currencyFormat = num => {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const loadSlipData = async (payfor) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/slipByPay/' + payfor;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data);
    } catch (error) {

    }
  };

  const loadEtcData = async (payfor) => {
    try {
      const url = 'https://eslip.snru.ac.th/backend/api/eslipData/etcByPay/' + payfor;
      const result = await axios(url, {
        cancelToken: source.token
      });
      return (result.data.data)
    } catch (error) {

    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        (moneyTypes.length > 0) && (await setColumns(moneyTypes));
        (typePersons.length > 0) && (await loadData(typePersons));
        return () => {
          source.cancel();
        };
      } catch (error) {
        console.log(error)
      }
    }
    fetchData()
    return () => {
      source.cancel();
    };
  }, [moneyTypes, typePersons, budgetYears, loadValue]);

  const printSlip = (data) => {

    pdfMake.fonts = {
      THSarabunNew: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew-Bold.ttf',
        italics: 'THSarabunNew-Italic.ttf',
        bolditalics: 'THSarabunNew-BoldItalic.ttf'
      },
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      }
    }
    const slips = slipDatas.filter((slip) => {
      return slip.citizen_id === data.citizen_id
    })

    let list_income_name = [];
    let list_income_value = [];
    let list_deduct_name = [];
    let list_deduct_value = [];
    slips.forEach(slip => {
      if (slip.tb_money_type.income_type_id === 1) {
        list_income_name.push(slip.tb_money_type.money_type_name);
        list_income_value.push(currencyFormat(slip.eslip_value));
      } else {
        list_deduct_name.push(slip.tb_money_type.money_type_name);
        list_deduct_value.push(currencyFormat(slip.eslip_value));
      }
    });

    let bankTextLines;
    if (String(data.citizen_id) === '3900200217239') {
      bankTextLines = [
        { text: '\nบัญชี กรุงไทย เลขที่: ', style: 'tableHeader', alignment: 'right' },
        { text: 'XXXXXX6987', style: 'subheader', alignment: 'right' },
        { text: '\nบัญชี กรุงศรี เลขที่: ', style: 'tableHeader', alignment: 'right' },
        { text: 'XXXXXX7013', style: 'subheader', alignment: 'right' }
      ];
    } else {
      bankTextLines = [
        { text: '\nบัญชี ' + data.bank_name + " เลขที่: ", style: 'tableHeader', alignment: 'right' },
        { text: 'XXXXXX'+ data.bank_account.substring(data.bank_account.length-4,data.bank_account.length), style: 'subheader', alignment: 'right' }
      ];
    }

    let docDefinition = {
      watermark: { text: 'มหาวิทยาลัยราชภัฏสกลนคร', color: 'green', opacity: 0.3, bold: true, italics: true },
      //userPassword: profile.person.citizen_id,
      //ownerPassword: '1480700055058',
      pageSize: 'A5',
      pageOrientation: 'landscape',
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          columns: [
            {
              image: images[0].image,
              width: 40
            },
            {
              text: [
                { text: 'มหาวิทยาลัยราชภัฏสกลนคร\n', style: 'header', alignment: 'left' },
                { text: 'เลขที่ 680 ถนนนิตโย ต. ธาตุเชิงชุม อำเภอเมือง จังหวัดสกลนคร 47000 \n โทรศัพท์ 042-970021,042-970094 IPPhone 932 โทรสาร 042-970022 E-mail webmaster@snru.ac.th', style: 'subheader', alignment: 'left' }
              ]
            },
            {
              width: 150,
              text: [
                { text: 'เลขที่: ', style: 'header', alignment: 'right' },
                { text: data.eslip_number, style: 'subheader', alignment: 'right' },
                ...bankTextLines
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: 35,
              text: 'ชื่อ - สกุล: \nเลขที่:', style: 'tableHeader', alignment: 'right'
            },
            {
              width: 115,
              text: data.fullname + "\n" + data.position_num, style: 'table1', alignment: 'left'
            },
            {
              width: 50,
              text: 'ตำแหน่ง: \nสังกัด:', style: 'tableHeader', alignment: 'right'
            },
            {
              width: 205,
              text: data.position_name + "\n" + data.agency_name, style: 'table1', alignment: 'left'
            },
            {
              width: 34,
              text: 'งวดที่จ่าย:', style: 'tableHeader', alignment: 'right'
            },
            {
              width: 70,
              text: moment(budgetYears).locale("th", localization).format('MMMM') + " " + (parseInt(moment(budgetYears).locale("th", localization).format('YYYY')) + 543),
              style: 'table1', alignment: 'left'
            }
          ]
        },
        {
          columns: [
            {
              table: {
                widths: [148, 52, 147, 52],
                heights: [20, 226, 20],
                body: [
                  [
                    { text: 'รายได้\nIncome', style: 'tableHeader', alignment: 'center' },
                    { text: 'จำนวนเงิน\nAmount', style: 'tableHeader', alignment: 'center' },
                    { text: 'รายการหัก\nDeduction', style: 'tableHeader', alignment: 'center' },
                    { text: 'จำนวนเงิน\nAmount', style: 'tableHeader', alignment: 'center' }
                  ],
                  [
                    {
                      ol: list_income_name, style: 'table1', alignment: 'left'
                    },
                    {
                      type: 'none',
                      ol: list_income_value, style: 'table1', alignment: 'right'
                    },
                    {
                      ol: list_deduct_name, style: 'table1', alignment: 'left'
                    },
                    {
                      type: 'none',
                      ol: list_deduct_value, style: 'table1', alignment: 'right'
                    }
                  ],
                  [
                    { text: 'รวมรายได้\n(Total Incom)', style: 'tableHeader', alignment: 'right', fillColor: '#dddddd' },
                    { text: data.sumincome, style: 'tableHeader', alignment: 'right' },
                    { text: 'รวมรายการหัก\n(Total Deduction)', style: 'tableHeader', alignment: 'right', fillColor: '#dddddd' },
                    { text: data.sumdeduct, style: 'tableHeader', alignment: 'right' }
                  ],
                ]
              }
            },
            [
              {
                style: 'tableExample',
                table: {
                  widths: [100],
                  body: [
                    [
                      {
                        text: 'วันที่พิมพ์สลิป\nPrint slip Date',
                        style: 'tableHeader',
                        fillColor: '#dddddd',
                        alignment: 'center'
                      },

                    ],
                    [
                      {
                        text: moment().locale("th", localization).format('DD MMMM') + " " + (parseInt(moment().locale("th", localization).format('YYYY')) + 543),
                        style: 'table2', alignment: 'center'
                      },
                    ]
                  ]
                }
              },
              {
                style: 'tableExample',
                table: {
                  widths: [100],
                  body: [
                    [
                      {
                        text: 'คงเหลือ\n',
                        style: 'tableHeader',
                        fillColor: '#dddddd',
                        alignment: 'center'
                      },

                    ],
                    [
                      {
                        text: data.sumtotal,
                        style: 'table2',
                        alignment: 'center'
                      },
                    ]
                  ]
                }
              },
              {
                style: 'tableExample',
                margin: [0, 50, 0, 0],
                table: {
                  widths: [111],
                  body: [
                    [
                      {
                        text: 'ลายมือชื่อ',
                        style: 'tableHeader',
                        fillColor: '#dddddd',
                        alignment: 'center'
                      },

                    ],
                    /*[
                      {
                        image: boss_license[0].image,
                        width: 60,
                        alignment: 'center'
                      }
                    ],*/
                    [
                    {
                      text: '\n.............................................\n',
                      style: 'table1',
                      fillColor: '#dddddd',
                      alignment: 'center'
                    },

                    ],
                    [
                      {
                        text: '(นายเกรียงไกร  มูลสาระ)\nนักวิชาการเงินและบัญชีชำนาญการ\nหัวหน้างานคลัง',
                        style: 'table1',
                        fillColor: '#dddddd',
                        alignment: 'center'
                      },

                    ],
                  ]
                }
              }
            ]
          ]
        },
      ],
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 14,
        columnGap: 10
      },
      styles: {
        header: {
          fontSize: 14,
          bold: true
        },
        tableExample: {
          margin: [0, 0, 0, 15]
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
          lineHeight: 0.8
        },
        tableHeader2: {
          fontSize: 12,
          bold: true,
          lineHeight: 0.8
        },
        table1: {
          fontSize: 12,
          lineHeight: 0.8
        },
        table2: {
          fontSize: 12,
          lineHeight: 1.5
        },
        subheader: {
          fontSize: 12,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 10
        }
      }
    };
    // const win = window.open('', '_blank');
    pdfMake.createPdf(docDefinition).print();
    //pdfMake.createPdf(docDefinition).open();
  }
  let sum_income1 = 0;
  let sum_deduct1 = 0;
  let sum_salary1 = 0;
  const getValueData = (newData, key) => {
    let value = 0;

    if (key === 'fullname' || key === 'citizen_id' || key === 'eslip_number' || key === 'agency_name' || key === 'position_name' || key === 'bank_name' || key === 'bank_account' || key === 'project_activities_id' || key === 'position_num' || key === 'etc' || key === 'sumincome' || key === 'sumdeduct' || key === 'sumtotal' || key === 'sumtotal2') {
      if (key === 'sumincome') {
        value = currencyFormat(sum_income1);
      }
      else if (key === 'sumdeduct') {
        value = currencyFormat(sum_deduct1);
      }
      else if (key === 'sumtotal2') {
        value = currencyFormat(sum_salary1 - sum_deduct1);
      }
      else if (key === 'sumtotal') {
        value = currencyFormat(sum_income1 - sum_deduct1);
      }
      else {
        value = newData[key];
      }
    } else {
      let income = moneyType.filter((mt) => {
        return mt.money_type_id === parseInt(key)
      })
      value = currencyFormat(parseFloat(newData[key].replace(',', '')));
      if (income[0].income_type_id === 1) {
        sum_income1 = sum_income1 + parseFloat(newData[key].replace(',', ''));
      } else {
        sum_deduct1 = sum_deduct1 + parseFloat(newData[key].replace(',', ''))
      }
      if (parseInt(key) === 1) {
        sum_salary1 = sum_salary1 + parseFloat(newData[key].replace(',', ''))
      }
    }
    return value;
  }

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        {(loading) && <LinearProgress color="primary" />}
        <MaterialTable
          icons={tableIcons}
          title="ข้อมูลรายการได้/รายการหัก บุคลากรมหาวิทยาลัยราชภัฏสกลนคร"
          columns={columns}
          data={personData}
          options={{
            //actionsColumnIndex: -1, กำหนดให้ ปุ๋มบันทึก อยู่ด้านหลัง
            exportButton: true,
            exportAllData: true,
            pageSize: 10,
            pageSizeOptions: [5, 10, 20, , 50, 100, personData.length],
            headerStyle: {
              backgroundColor: '#fafafa',
              color: '#333'
            }
          }}
          actions={[
            {
              tooltip: 'พิมพ์สลิปเงินเดือน',
              icon: () => <PrintIcon />,
              onClick: (evt, data) => printSlip(data)
            }
          ]}
          editable={{
            onRowDelete: async oldData => {
              try {
                let obj = {};
                const apiUrl = 'https://eslip.snru.ac.th/backend/api/eslipData/deleteData/';
                const response = await axios.post(apiUrl, { citizen_id: oldData.citizen_id, payslip_for: budgetYears });

                const apiUrl1 = 'https://eslip.snru.ac.th/backend/api/eslipData/deleteEtcData/';
                await axios.post(apiUrl1, { citizen_id: oldData.citizen_id, payslip_for: budgetYears });

                Object.keys(oldData).map((key, index) => {
                  obj = { ...obj, [key]: (key === 'fullname' || key === 'citizen_id' || key === 'eslip_number' || key === 'agency_name' || key === 'position_name' || key === 'position_num' || key === 'sumincome' || key === 'sumdeduct' || key === 'sumtotal2' || key === 'sumtotal') ? (oldData[key]) : '-' }
                })

                const index = personData.indexOf(oldData);
                let newArr = [...personData];
                newArr[index] = obj;
                setPersonData(newArr);
                setSnackVariant('success');
                setSnackMessage(response.data.message);
                setOpenSnack(true);
              } catch (error) {
                setSnackVariant('error');
                setSnackMessage(error.response.data.error.message)
                setOpenSnack(true);
              }
            },
            onRowUpdate: async (newData, oldData) => {
              try {
                let value = [];
                let value2 = [];
                let obj = {};
                Object.keys(newData).map((key, index) => {
                  if (key !== 'fullname' && key !== 'citizen_id' && key !== 'eslip_number' && key !== 'agency_name' && key !== 'position_name' && key !== 'bank_account' && key !== 'project_activities_id' && key !== 'bank_name' && key !== 'position_num' && key !== 'etc' && key !== 'sumincome' && key !== 'sumdeduct' && key !== 'sumtotal' && key !== 'sumtotal2' && parseFloat(newData[key].replace(',', '')) > 0) {
                    value.push({
                      ...data,
                      citizen_id: newData.citizen_id,
                      money_type_id: key,
                      eslip_value: parseFloat(newData[key].replace(',', '')),
                      payslip_for: budgetYears,
                      user_update: profile.person.citizen_id,
                    })
                  }
                  else {
                    (newData.bank_account) &&
                      value2.push({
                        ...data,
                        citizen_id: newData.citizen_id,
                        bank_name: newData.bank_name,
                        bank_account: newData.bank_account,
                        project_activities_id: newData.project_activities_id,
                        payslip_for: budgetYears,
                        etc: newData.etc,
                        user_update: profile.person.citizen_id,
                      })
                  }
                });

                let response;
                if (newData.bank_account) {
                  const apiUrl1 = 'https://eslip.snru.ac.th/backend/api/eslipData/deleteEtcData/';
                  await axios.post(apiUrl1, { citizen_id: oldData.citizen_id, payslip_for: budgetYears });
                  const apiUrl = 'https://eslip.snru.ac.th/backend/api/eslipData/saveEtcData';
                  response = await axios.post(apiUrl, [value2[0]]);
                }
                const apiUrl1 = 'https://eslip.snru.ac.th/backend/api/eslipData/deleteData/';
                await axios.post(apiUrl1, { citizen_id: oldData.citizen_id, payslip_for: budgetYears });
                const apiUrl = 'https://eslip.snru.ac.th/backend/api/eslipData/saveMultiData';
                response = await axios.post(apiUrl, value);

                Object.keys(newData).map((key, index) => {
                  obj = { ...obj, [key]: getValueData(newData, key) }
                })

                //console.log(obj, incomeType)

                const index = personData.indexOf(oldData);
                let newArr = [...personData];
                newArr[index] = obj;
                setPersonData(newArr);
                setSnackVariant('success');
                setSnackMessage(response.data.message);
                setOpenSnack(true);
              } catch (error) {
                setSnackVariant('error');
                setSnackMessage(error.response.data.error.message)
                setOpenSnack(true);
              }
            }
          }}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open={openSnack}
          autoHideDuration={2000}
          onClose={handleClose}
        >
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant={snackVariant}
            message={snackMessage}
          />
        </Snackbar>
      </div>
    </Paper>
  )
};

SlipsTable.propTypes = {
  className: PropTypes.string,
  budgetYears: PropTypes.string,
  typePersons: PropTypes.array,
  moneyTypes: PropTypes.array,
  loadValue: PropTypes.array,
};

export default SlipsTable;
